export default __webpack_public_path__ + "static/media/notstarted.2894a97b.svg";